module.exports = function getResource(label, vars = []) {
    const resources = {
        paymentErrorTitle: 'Erreur',
        paymentCancellation: 'Nous n’avons pas été en mesure de passer votre commande. Problème de connexion à PayPal. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.<br /><br />S’il y a lieu, nous avons reversé tout frais en cours sur votre compte.',
        paymentErrorMessage: 'Problème de connexion à PayPal. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.',
        authorizationErrorMessage: 'Désolé, nous ne pouvons pas autoriser votre paiement PayPal. Veuillez sélectionner un autre mode de paiement. Nous avons reversé tous frais en cours sur votre compte, si applicable.',
        okButton: 'OK'
    };

    return resources[label];
};
